<template>
  <ul class="recent-posts">
    <li v-for="recentPost in recentPostsItems" :key="recentPost.Title">
      <div class="recent-title">
        <a href="recentPost.Slug"> {{ recentPost.Title }}</a>
      </div>
      <div class="recent-info">
        <span> {{ recentPost.Excerpt }}</span>
      </div>
      <div class="recent-date">
        <span>{{ recentPost.PubDate }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "RecentPosts",
  props: {
    recentPostsItems: Array,
  },
  methods: {},
};
</script>

<style lang="postcss">
.recent-posts {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.4em;
  li {
    overflow: hidden;
    a {
      text-decoration: none;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .recent-title {
  }

  .recent-date {
  }

  .recent-info {
    margin-top: 5px;
    font-size: 13px;
    color: #888;
  }
}
</style>